export default __webpack_public_path__ + "static/media/ER17.840247fb.png";